import { Product, useGetProductQuery } from 'integration/resources/products'

export const useProductScreen = (idOrSlug: string) => {
  const product = useGetProductQuery(idOrSlug)

  return { product: product.data?.data as Product }
}
